import { ToastProgrammatic as Toast } from 'buefy';

import store from '../store';

const NEED_COMPANY_MESSAGE = {
  type: 'is-warning',
  message: 'Necesitas completar la infomación de tu compañia.',
  duration: 5000,
  position: 'is-top',
};


function checkHaveEfirma(to, from, next) {
  if (!store.state.company.haveEfirma) {
    Toast.open(NEED_COMPANY_MESSAGE);
    next({ name: 'Company', params: { id: store.state.company.id } });
  } else {
    next();
  }
}

async function beforeEnter(to, from, next) {
  const { companyId } = store.state.auth;
  const { haveCompany } = store.state.company;

  const toCompany = to.name === 'Company';
  const needConfig = !haveCompany;

  if (needConfig && !toCompany) {
    Toast.open(NEED_COMPANY_MESSAGE);
    next({ name: 'Company' });
  } else if (needConfig && toCompany) {
    if (!to.params.id && companyId !== 0) {
      next({ name: 'Company', params: { id: companyId } });
    } else {
      next();
    }
  } else next();
}

export default {
  checkHaveEfirma,
  beforeEnter,
};
